<script>
import About from "./About.svelte";
import Contact from "./Contact.svelte";
import Header from "./Header.svelte";
import Me from "./Me.svelte";
import Price from "./Price.svelte";
</script>

<main>
    <Header />
    <About />
    <Me />
    <Price />
    <Contact />
</main>

<style>
    main {
        display: flex;
        justify-content: center;
        flex-direction: column;
        width: 100%;
    }

</style>
